import { Component, Inject, Injector, Type } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { WsDialogInjectable } from "./ws-dialog-content-base";

@Component({
  selector: 'ws-dialog',
  templateUrl: './ws-dialog.component.html',
  styleUrls: ['./ws-dialog.component.scss']
})
export class WsDialogComponent {

  dynamicComponent: Type<any>;
  title: string;
  wsDialogInjector: Injector;

  constructor(
    private dlg: MatDialogRef<WsDialogComponent>,
    injector: Injector,
    @Inject(MAT_DIALOG_DATA) public data: {
      content: Type<any>,
      title: string,
      inputs: { [key: string]: any },
    },
  ) {
    this.dynamicComponent = data.content;
    this.title = data.title;

    this.wsDialogInjector = Injector.create({
      providers: [{ provide: WsDialogInjectable, useValue: {
        inputs: data.inputs,
        closeClicked: this.closeClicked.bind(this),
      } }],
      parent: injector,
    })
  }

  closeClicked(data?: any) {
    this.dlg.close(data);
  }

  saveClicked() {
    const dialogCtx = this.wsDialogInjector.get(WsDialogInjectable);
    if (dialogCtx.getData) {
      const data = dialogCtx.getData();
      this.closeClicked(data);
    } else {
      console.warn('No getData() defined in the child component');
      this.closeClicked();
    }
  }
}